// contexts/SocketContext.jsx
import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { io } from "socket.io-client";
import { API_URL_FROM_ENV } from "../config/apiConfig";

const SocketCtx = createContext(null);

export function SocketProvider({ children }) {
  const socketRef = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return; // sem token, sem socket

    const fallbackOrigin = window.location.origin.includes("localhost")
      ? "http://localhost:3000"
      : window.location.origin;
    // Já sem o /api: no socket.io-client o path da URL vira namespace, e
    // "https://host/api" conectaria no namespace /api, que não existe.
    const base =
      API_URL_FROM_ENV || process.env.REACT_APP_SOCKET_URL || fallbackOrigin;
    const s = io(base, {
      path: "/socket.io",
      auth: { token },
      transports: ["websocket"],
      withCredentials: false,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 600,
      reconnectionDelayMax: 6000,
    });

    socketRef.current = s;

    const onConnect = () => {
      setReady(true);
      // logs úteis de diagnóstico
      console.debug("[socket] connected", s.id);
    };
    const onErr = (e) =>
      console.warn("[socket] connect_error:", e?.message || e);
    const onDisc = (r) => console.warn("[socket] disconnected:", r);

    s.on("connect", onConnect);
    s.on("connect_error", onErr);
    s.on("disconnect", onDisc);

    return () => {
      try {
        s.off("connect", onConnect);
        s.off("connect_error", onErr);
        s.off("disconnect", onDisc);
        s.disconnect();
      } catch {}
      socketRef.current = null;
      setReady(false);
    };
  }, []);

  return (
    <SocketCtx.Provider value={{ socketRef, ready }}>
      {children}
    </SocketCtx.Provider>
  );
}

export function useSocketRef() {
  const ctx = useContext(SocketCtx);
  return ctx?.socketRef ?? { current: null };
}
export function useSocketReady() {
  const ctx = useContext(SocketCtx);
  return !!ctx?.ready;
}
